import { Building2, MonitorSmartphone } from 'lucide-react';
import React, { FC } from 'react';
import styled from 'styled-components';

import {
  useGetDeviceCountFromFirebase,
  useGetOrganizationsCountFromFirebase,
} from '../../../../queries';
import { AiResetCountdown } from '../AiResetCountdown';

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  margin: 24px 0;
`;

const Card = styled.div`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-weight: 700;
  color: #6b7280;
`;

const IconWrap = styled.div<{ $bg: string }>`
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: ${({ $bg }) => $bg};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Value = styled.div`
  font-size: 28px;
  font-weight: 800;
  color: #111827;
  font-variant-numeric: tabular-nums;
  line-height: 1.1;
`;

const Subline = styled.div`
  font-size: 12px;
  color: #6b7280;
`;

interface CountCardProps {
  label: string;
  icon: React.ReactNode;
  color: string;
  count?: number;
  isLoading: boolean;
  isError: boolean;
  subline: string;
}

const CountCard: FC<CountCardProps> = ({
  label, icon, color, count, isLoading, isError, subline,
}) => {
  let value: string;
  if (isLoading) value = '…';
  else if (isError || count === undefined) value = '—';
  else value = count.toLocaleString();

  return (
    <Card>
      <Header>
        <IconWrap $bg={color}>{icon}</IconWrap>
        {label}
      </Header>
      <Value>{value}</Value>
      <Subline>{subline}</Subline>
    </Card>
  );
};

export const PlatformCountsSection: FC = () => {
  const organizations = useGetOrganizationsCountFromFirebase();
  const devices = useGetDeviceCountFromFirebase();

  return (
    <Grid>
      <CountCard
        label="Organizations"
        icon={<Building2 size={16} />}
        color="#1a4d4d"
        count={organizations.data}
        isLoading={organizations.isLoading}
        isError={organizations.isError}
        subline="organizations collection"
      />
      <CountCard
        label="Devices"
        icon={<MonitorSmartphone size={16} />}
        color="#0ea5e9"
        count={devices.data}
        isLoading={devices.isLoading}
        isError={devices.isError}
        subline="pods collection"
      />
      {/* W tej samej siatce co liczniki, żeby kafle miały wspólną linię. */}
      <AiResetCountdown />
    </Grid>
  );
};
